import { useEffect, useRef } from "react"
import useAuth from "@/hooks/useAuth"
import { apiSettings } from "@/api/client"
import { EventSource } from "eventsource"
import { AppEventItemScheme } from "../../../../../backend/src/routes/schemes"
import { ApiAppEventItemSchemeToEventMapper } from "../utils/mappers"
import { AppEventProviderActionsProps } from "./useAppEventProvider.actions"

const useAppEventProviderSse = ({ addEvent }: AppEventProviderActionsProps) => {
    const { accessToken } = useAuth()
    const es = useRef<EventSource | null>(null)
    useEffect(() => {
        if (!es.current && accessToken) {
            const settings = apiSettings({ token: accessToken })
            const eSource = new EventSource(settings.baseURL + "/event", {
                fetch: (input, init) =>
                    fetch(input, {
                        ...init,
                        headers: {
                            ...init?.headers,
                            Authorization: settings.headers.Authorization!,
                        },
                    }),
            })
            es.current = eSource
        }
        return () => {
            es.current?.close()
            es.current = null
        }
    }, [accessToken, addEvent])

    useEffect(() => {
        const parseEvent = (event: MessageEvent<any>) => {
            const parsed = JSON.parse(event.data) as AppEventItemScheme
            addEvent(ApiAppEventItemSchemeToEventMapper(parsed))
        }

        if (es.current) es.current.addEventListener("all", parseEvent)
        return () => {
            if (es.current) es.current.removeEventListener("all", parseEvent)
        }
    }, [addEvent])
}
export default useAppEventProviderSse
